<template>
    <div class="mx-2 flex flex-col gap-1 py-2" v-cloak>

        <div v-if="fetching" class="my-1 flex items-center justify-center gap-2">
            <span class="text-sm text-gray-100">Fetching...</span>
            <spinner />
        </div>

        <div v-if="!fetching" class="flex flex-col gap-1">

            <div class="uppercase text-xs text-center font-semibold mb-2">{{ sponsor !== null ? sponsor.name : 'New Sponsor' }}</div>

            <div v-if="sponsor.bg_lobby || sponsor.bg_game"
                class="flex items-center justify-center gap-2 mb-2 max-w-sm mx-auto">
                <div v-if="sponsor.bg_lobby" class="w-40 flex flex-col items-center justify-center">
                    <img :src="sponsor.bg_lobby" class="w-40 object-cover" />
                    <span class="text-xs uppercase text-inner-border">Lobby</span>
                </div>
                <div v-if="sponsor.bg_game" class="w-40 flex flex-col items-center justify-center">
                    <img :src="sponsor.bg_game" class="w-40 object-cover" />
                    <span class="text-xs uppercase text-inner-border">Game</span>
                </div>
            </div>

            <div v-else class="flex items-center justify-center text-sm text-red-400 dark:text-red-200 italic mb-4">
                No images found for backgrounds.
            </div>

            <div class="flex flex-col mb-4">

                <div class="flex flex-col mb-4">
                    <div class="text-xs uppercase text-gray-400 mb-1">Name</div>
                    <div>
                        <input class="w-full rounded text-black h-8 px-1" type="text" v-model="sponsor.name">
                    </div>
                    <div class="text-sm bg-red-500 text-white rounded px-1 py-1 mt-1" v-if="errors && errors.name">
                        {{ errors.name[0] }}
                    </div>
                </div>

                <div class="flex flex-col mb-4">
                    <div class="text-xs uppercase text-gray-400 mb-1">Subdomain</div>
                    <div>
                        <input class="w-full rounded text-black h-8 px-1" type="text" v-model="sponsor.subdomain">
                    </div>
                    <div class="text-sm bg-red-500 text-white rounded px-1 py-1 mt-1" v-if="errors && errors.subdomain">
                        {{ errors.subdomain[0] }}
                    </div>
                </div>

                <div class="flex flex-col mb-4">
                    <div class="text-xs uppercase text-gray-400 mb-1">Wallet</div>
                    <div>
                        <input class="w-full rounded text-black h-8 py-2 px-1 text-xs" type="text" v-model="sponsor.wallet">
                    </div>
                    <div class="text-sm bg-red-500 text-white rounded px-1 py-1 mt-1" v-if="errors && errors.wallet">
                        {{ errors.wallet[0] }}
                    </div>
                </div>

                <div class="flex flex-col mb-4">
                    <div class="text-xs uppercase text-gray-400 mb-1">Status</div>
                    <div>
                        <select class="w-full rounded text-black h-8 px-1" v-model="sponsor.active">
                            <option :value="false">Inactive</option>
                            <option :value="true">Active</option>
                        </select>
                    </div>
                    <div class="text-sm bg-red-500 text-white rounded px-1 py-1 mt-1" v-if="errors && errors.active">
                        {{ errors.active[0] }}
                    </div>
                </div>

            </div>

            <div class="flex items-center justify-end gap-1">
                <button @click.prevent="back"
                    class="bg-gray-700 text-white text-xs uppercase rounded py-1 px-2">Cancel</button>
                <button @click.prevent="submit" :disabled="submiting"
                    class="bg-green-600 disabled:opacity-50 text-white text-xs uppercase rounded py-1 px-2">
                    Submit
                </button>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AdminSubPanelSponsor',
    props: ['token', 'sponsor_id', 'page'],
    data() {
        return {
            ready: false,
            fetching: false,
            submiting: false,
            errors: {},
            sponsor: {
                id: null,
                name: '',
                subdomain: '',
                wallet: '',
                bg_game: '',
                bg_lobby: '',
                active: false
            },
        }
    },
    async mounted() {
        if (this.sponsor_id !== null) {
            await this.fetchData(this.sponsor_id)
        }
        this.ready = true
    },
    watch: {
        sponsor_id(value) {
            if (this.ready && value !== null) {
                this.fetchData(value)
            }
        }
    },
    methods: {
        reset() {
            this.sponsor = {
                name: '',
                subdomain: '',
                wallet: '',
                active: false
            }
        },
        back() {
            this.$emit('back-to-sponsors', this.page)
        },
        submit() {
            this.submiting = true
            const data = {
                id: this.sponsor.id,
                name: this.sponsor.name,
                subdomain: this.sponsor.subdomain,
                wallet: this.sponsor.wallet,
                active: this.sponsor.active
            }
            axios.post('/api/admin/sponsors/submit', data, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.$toast.success(response.data.message)
                this.$emit('back-to-sponsors', this.page)
            }).catch((err) => {
                if (err.response && err.response.status === 422) {
                    this.errors = err.response.data.errors
                }
                this.$toast.error('Error submiting Sponsor.')
            }).finally(() => {
                this.submiting = false
            })
        },
        async fetchData(sponsor_id) {
            this.fetching = true
            axios.get('/api/admin/sponsors/show/' + sponsor_id, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.sponsor = response.data
            }).catch(() => {
                this.$toast.error('Error fetching Sponsor.')
            }).finally(() => {
                this.fetching = false
            })
        },
    }
}
</script>
